import { z } from "zod";

export const taskDetailPageSearchSchema = z.object({
  action: z.string().optional().catch(undefined),
});
